import type { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost";
};

export function Button({ variant = "primary", className = "", ...rest }: Props) {
  return (
    <button
      className={`btn btn--${variant}${className ? ` ${className}` : ""}`}
      type={rest.type ?? "button"}
      {...rest}
    />
  );
}
